// Default values to support for the serialization of the shareable

import type { DataTableV2Config } from './public.api.js';

// DataTableV2 config props
export const DEFAULT_DATATABLE_V2_CONFIG: DataTableV2Config = {
  fullWidth: false,
  fullHeight: false,
  lineWrap: false,
  selectableRows: undefined,
  resizable: false,
  sortable: false,
  pagination: {},
  variant: {
    contained: true,
    fontStyle: 'text',
    headers: 'default',
    rowDensity: 'default',
    rowSeparation: 'horizontalDividers',
    verticalDividers: false,
  },
  columnVisibility: {},
  rowThresholds: [],
};

/**
 * The default page index if pagination is defined, but no page index is set.
 */
export const DEFAULT_PAGINATION_PAGE_INDEX = 0;

/**
 * The default page size options if pagination is active.
 */
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 250, 500, 1000];

/**
 * The default page size option, set to `100`.
 */
export const DEFAULT_PAGE_SIZE_OPTION = DEFAULT_PAGE_SIZE_OPTIONS[3];

/**
 * The default min-width of the DataTable column.
 */
export const DATA_TABLE_DEFAULT_MIN_COLUMN_WIDTH = 30;

/**
 * The default width of the DataTable column.
 */
export const DATA_TABLE_DEFAULT_COLUMN_WIDTH = 100;

/**
 * DataTable scrollbar compensation to handle container widths
 */
export const DATA_TABLE_SCROLLBAR_COMPENSATION = 16;

export const DEFAULT_WIDTH_OF_ACTION_COLUMN = 150;

export const DATA_TABLE_EXPANDABLE_ROW_TRIGGER_ID =
  'strato-table-expandable-row-trigger';
export const DATA_TABLE_SELECTABLE_ROW_TRIGGER_ID =
  'strato-table-selectable-row-trigger';
export const DATA_TABLE_SUB_ROW_TRIGGER_ID =
  'strato-table-sub-rows-all-trigger';
export const DATA_TABLE_ACTION_COLUMN_ID = 'strato-table-action-column';

// z-index values used for data table
export const DATA_TABLE_ZINDEX_CONFIG = {
  DEFAULT: 1,
  STICKY: 2,
  OVERLAY: 3,
  HEADER: 4,
} as const;
